import React, { useEffect, useState } from 'react'
import { ERROR_MESSAGE } from '../../types/enums'

interface ErrorMessageProps {
  idError: string
  isVisible: boolean
  errorMessage?: string
}

/** Componente che permette la visualizzazione di un messaggio d'errore
 *
 * @param idError id del componente
 * @param isVisible se true, il messaggio verrà visualizzato
 * @param errorMessage il messaggio da visualizzare
 */
const ErrorMessage = ({ idError, isVisible, errorMessage }: ErrorMessageProps) => {
  const [message, setMessage] = useState<string>(errorMessage ?? ERROR_MESSAGE.msgRetry)

  useEffect(() => {
    if (errorMessage) setMessage(errorMessage)
  }, [errorMessage])

  return (
    <div
      id={idError + '-error'}
      className={`mt-5 mb-2 py-1.5 px-2.5 font-assistant text-[1.2em] font-bold text-errorRed border-2 border-errorRed ${!isVisible ? 'hidden' : ''}`}>
      {message}
    </div>
  )
}

export default ErrorMessage
